var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOngoingImpactRecovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9075_61",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9075_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.125 3C17.7917 3 19.1875 3.61667 20.3125 4.85C21.4375 6.08333 22 7.55 22 9.25C22 9.55 21.9833 9.84583 21.95 10.1375C21.9167 10.4292 21.8583 10.7167 21.775 11H15.525L13.825 8.45C13.7417 8.31667 13.625 8.20833 13.475 8.125C13.325 8.04167 13.1667 8 13 8C12.7833 8 12.5875 8.06667 12.4125 8.2C12.2375 8.33333 12.1167 8.5 12.05 8.7L10.7 12.75L9.825 11.45C9.74167 11.3167 9.625 11.2083 9.475 11.125C9.325 11.0417 9.16667 11 9 11H2.225C2.14167 10.7167 2.08333 10.4292 2.05 10.1375C2.01667 9.84583 2 9.55833 2 9.275C2 7.55833 2.55833 6.08333 3.675 4.85C4.79167 3.61667 6.18333 3 7.85 3C8.65 3 9.40417 3.15833 10.1125 3.475C10.8208 3.79167 11.45 4.23333 12 4.8C12.5333 4.23333 13.1542 3.79167 13.8625 3.475C14.5708 3.15833 15.325 3 16.125 3ZM12 21C11.7 21 11.4125 20.9458 11.1375 20.8375C10.8625 20.7292 10.6167 20.5667 10.4 20.35L3.7 13.625C3.6 13.525 3.50833 13.425 3.425 13.325C3.34167 13.225 3.25833 13.1167 3.175 13H8.45L10.15 15.55C10.2333 15.6833 10.35 15.7917 10.5 15.875C10.65 15.9583 10.8083 16 10.975 16C11.1917 16 11.3917 15.9333 11.575 15.8C11.7583 15.6667 11.8833 15.5 11.95 15.3L13.3 11.25L14.15 12.55C14.25 12.6833 14.375 12.7917 14.525 12.875C14.675 12.9583 14.8333 13 15 13H20.8L20.3 13.6L13.575 20.35C13.3583 20.5667 13.1167 20.7292 12.85 20.8375C12.5833 20.9458 12.3 21 12 21Z",
    fill: "#188AEB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingImpactRecovery);
export default __webpack_public_path__ + "static/media/ongoing-impact-recovery.9e5618432be11365f0b09b8208a73692.svg";
export { ForwardRef as ReactComponent };